import { useStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { computed } from 'vue'

import type { SidebarMode } from '@/domains/admin-panel/store/use-sidebar-preferences-store/useSidebarPreferencesStore.types'

import {
  DEFAULT_SIDEBAR_MODE,
  SIDEBAR_MODES
} from '@/domains/admin-panel/store/use-sidebar-preferences-store/useSidebarPreferencesStore.consts'

// Browser storage, per device. Moving it to the user's account is a backend decision.
const MODE_KEY = 'twn:navigation:sidebar-mode'

const isSidebarMode = (value: unknown): value is SidebarMode => SIDEBAR_MODES.includes(value as SidebarMode)

/** One sidebar mode for the whole admin: the rail, the panel and the `[` shortcut all read and write it. */
export const useSidebarPreferencesStore = defineStore('sidebarPreferences', () => {
  const stored = useStorage<string>(MODE_KEY, DEFAULT_SIDEBAR_MODE)

  // A value from an older build, or typed by hand, reads as the default rather than breaking the layout.
  const mode = computed<SidebarMode>({
    get: () => (isSidebarMode(stored.value) ? stored.value : DEFAULT_SIDEBAR_MODE),
    set: next => {
      stored.value = next
    }
  })

  const setMode = (next: SidebarMode) => {
    mode.value = next
  }

  return { mode, setMode }
})
